const CSV_ESCAPE_CHAR = '"';

export function escapeCsvValue(value: string, delimiter: string) {
  if (value.includes(CSV_ESCAPE_CHAR)) {
    value = value.split(CSV_ESCAPE_CHAR).join(`${CSV_ESCAPE_CHAR}${CSV_ESCAPE_CHAR}`);
    value = `${CSV_ESCAPE_CHAR}${value}${CSV_ESCAPE_CHAR}`;
  } else if (value.includes(delimiter)) {
    value = `${CSV_ESCAPE_CHAR}${value}${CSV_ESCAPE_CHAR}`;
  }
  return value;
}

/**
 * The CSV text of `rows`: one header line, one line per row, CRLF-separated,
 * every value escaped for `delimiter`.
 */
export function buildCsv<T>(
  rows: readonly T[],
  columns: readonly string[],
  delimiter: string,
  read: {
    header: (columnId: string) => string;
    cell: (columnId: string, row: T, rowIndex: number) => string;
  }
): string {
  const lines: string[] = Array(rows.length + 1);
  lines[0] = columns
    .map((columnId) => escapeCsvValue(read.header(columnId), delimiter))
    .join(delimiter);
  rows.forEach((row, rowIndex) => {
    lines[rowIndex + 1] = columns
      .map((columnId) => escapeCsvValue(read.cell(columnId, row, rowIndex), delimiter))
      .join(delimiter);
  });
  return lines.join('\r\n');
}

/** `<prefix>_<yyyyMMddHHmmss>.csv`, the time taken in UTC. */
export function csvFileName(prefix: string, now: Date = new Date()): string {
  const stamp = now
    .toISOString()
    .replaceAll('T', '')
    .replaceAll('-', '')
    .replaceAll(':', '')
    .split('.')[0];
  return `${prefix}_${stamp}.csv`;
}

export function downloadCsvFile(filename: string, content: string) {
  const link = document.createElement('a');
  if (link.download !== undefined) {
    const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
